import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=147241b4&scoped=true"
import script from "./Auth.vue?vue&type=script&setup=true&lang=js"
export * from "./Auth.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Auth.vue?vue&type=style&index=0&id=147241b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147241b4",
  null
  
)

export default component.exports